// extracted by mini-css-extract-plugin
export default {"wrapper":"Overview_style_wrapper__Qcczx","steps":"Overview_style_steps__c6EJg","item":"Overview_style_item__E274J","rotate":"Overview_style_rotate__l9VOh"};